import * as React from 'react'
// libs
import styled from 'styled-components'
// themes
import { colors } from 'themes'

// styled
const Wrapper = styled.div`
  align-items: center;
  background-color: ${colors.gray290};
  border-radius: 16px;
  box-sizing: border-box;
  color: ${colors.black};
  display: flex;
  margin-right: 4px;
  margin-top: 4px;
  min-width: 0;
  overflow: hidden;
  padding: 2px;

  > div {
    color: ${colors.gray450};
    font-size: 13px;
    padding: 6px 10px 6px 15px;
  }
`
// types
interface ChipProps {
  label: string | number
}

const Chip: React.FC<ChipProps> = ({ label }) => {
  return (
    <Wrapper>
      <div>{label}</div>
    </Wrapper>
  )
}

export default Chip
